import * as React from 'react'
// This component is a hack to be able to trim ticks value in Nivo charts.
// This allows us to keep the key intact while limiting the number of
// chars to display. This is to avoid annoying looking charts when
// the ticks are made of long questions (ie)
// Inspired by this thread: https://github.com/plouc/nivo/issues/353
import { SVGProps } from 'react'

import i18n from 'modules/core/lib/i18n'

interface LeftTickProps {
  textAnchor: string
  textBaseline: string
  value: string
  x: number
  y: number
}

const LeftTick = ({ textAnchor, textBaseline, value, x, y }: LeftTickProps) => {
  const MAX_LENGTH = 30
  const label = value ?? i18n.t('common.anonymous_user')
  const stringLength = label.length

  const trimmedString =
    stringLength > MAX_LENGTH ? `${label.slice(0, MAX_LENGTH - 3)}...` : `${label}`

  return (
    <g transform={`translate(${x},${y})`}>
      <text
        alignmentBaseline={textBaseline as SVGProps<SVGTextElement>['alignmentBaseline']}
        textAnchor={textAnchor as SVGProps<SVGTextElement>['textAnchor']}
      >
        <tspan
          dx={-15}
          style={{
            fontFamily: 'sans-serif',
            fontSize: '11px',
          }}
        >
          {trimmedString}
        </tspan>
      </text>
    </g>
  )
}

export default LeftTick
